module.exports = __webpack_public_path__ + "img/crossword.e08a6961.svg";